import React from 'react';
import {checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {transactionType} from '../../Page/TransactionSummaryPage/Shared/Constants';
import {setTittle, setLabels} from './helper/GeneralDetailsHelper';
const GeneralDetailsCancelDeal = ({generalDetails, data, dealType, reasonCode}) => {
  const showComponent = checkSectionValid(generalDetails);
  const title = setTittle(dealType, data);
  const subscriberNumbers = generalDetails.subscriberNumberList;
  let labels = {};
  labels = setLabels(dealType, reasonCode);

  return (
    <div className='general-details'>
      <label className='general-details__topic'>{title}</label>
      <div className='content-collapse-container'>
        <div className='general-details__subscriber-content '>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>{labels.createOrder}</label>
              <span className='general-details__block-fram'>{generalDetails.createOrderDate}</span>
            </div>
          </div>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>{labels.saleDate}</label>
              <span className='general-details__block-fram'>{generalDetails.saleDate}</span>
            </div>
          </div>
          <div className='general-details__row1'>
            <div className='general-details__holder1'>
              <label>{labels.orderNumber}</label>
              <span className='general-details__block-fram'>{generalDetails.orderNumber}</span>
            </div>
          </div>
          {/*<div className='general-details__row1'>*/}
          {/*  <div className='general-details__holder1'>*/}
          {/*    <label>מועד סגירת החשבונית</label>*/}
          {/*    <span className='general-details__block-fram'>{'ב- ' + generalDetails.billCycle + ' לכל חודש'}</span>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        {data.generalDetailsMessage.value !== '' && <p className='general-details__message'>{data.generalDetailsMessage.value}</p>}
      </div>
    </div>
  );
};
// function  setTittle(dealType,context)  {
//   let tittle;
//   switch (dealType){
//     case transactionType.CancelDeal:
//       tittle = context.generalCancelDealTopic.value
//       break;
//     default:
//       tittle = context.generalDetailsTopic.value
//       break;
//   }
//
//   return tittle;
// }
// function setLabels(dealType) {
//   const labels = {};
//
//   switch (dealType) {
//     case transactionType.Change:
//     case transactionType.Provide:
//       labels.saleDate = 'תאריך העסקה';
//       labels.orderNumber = 'מספר הזמנה';
//       break;
//     case transactionType.Disconnect:
//       labels.saleDate = 'תאריך בקשת ניתוק';
//       labels.orderNumber = 'מספר הזמנת ניתוק';
//       break;
//     default:
//       labels.saleDate = 'תאריך ביטול עסקה';
//       labels.orderNumber = 'מספר הזמנת עסקת ביטול';
//       labels.createOrder = 'תאריך בו בוצעה העסקה המקורית'
//   }
//
//   return labels;
// }

export default GeneralDetailsCancelDeal;
